import React, { useState } from "react";
import { Footer, Sidebar } from "../../packages/excalidraw/index";
import { EncryptedIcon } from "./EncryptedIcon";
import { ExcalidrawPlusAppLink } from "./ExcalidrawPlusAppLink";
import { isExcalidrawPlusSignedUser } from "../app_constants";
import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";

export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    const [docked, setDocked] = useState(false);

    return (
      <>
        <Sidebar name="custom" docked={docked} onDock={setDocked}>
          <Sidebar.Header />
          <Sidebar.Tabs>
            <Sidebar.Tab tab="one">Tab one!</Sidebar.Tab>
            <Sidebar.Tab tab="two">Tab two!</Sidebar.Tab>
            <Sidebar.TabTriggers>
              <Sidebar.TabTrigger tab="one">One</Sidebar.TabTrigger>
              <Sidebar.TabTrigger tab="two">Two</Sidebar.TabTrigger>
            </Sidebar.TabTriggers>
          </Sidebar.Tabs>
        </Sidebar>

        <Footer>
          <div
            style={{
              display: "flex",
              gap: ".5rem",
              alignItems: "center",
            }}
          >
            <Sidebar.Trigger
              name="custom"
              tab="one"
              style={{
                marginLeft: "0.5rem",
                background: "#70b1ec",
                color: "white",
                width: "fit-content",
              }}
            >
              Map
            </Sidebar.Trigger>
            {isVisualDebuggerEnabled() && <DebugFooter onChange={onChange} />}
            {isExcalidrawPlusSignedUser ? (
              <ExcalidrawPlusAppLink />
            ) : (
              <EncryptedIcon />
            )}
          </div>
        </Footer>
      </>
    );
  },
);
